import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import {
  SystemElasticSearchForm,
  mountForm,
  unmountForm,
  showToast,
} from '@kineticdata/react';
import { generateFormButtons, FormError } from '@kineticdata/ui';
import { regRoute, regSaga } from '../../store';
import { Map } from 'immutable';
import { restartResourcesToastDefinition } from './SystemSetupTrustedCertificatesNew';
import { reload } from '../common/NoticesDropdown';

const formKey = 'system-setup-elastic-search';

regRoute('SYSTEM_LOGHUB_PAGE', '/system/setup/infra/loghub');

regSaga(
  takeEvery('ENTER_SYSTEM_LOGHUB_PAGE', function* () {
    yield call(mountForm, formKey);
  }),
);
regSaga(
  takeEvery('LEAVE_SYSTEM_LOGHUB_PAGE', function* () {
    yield call(unmountForm, formKey);
  }),
);

const handleSave = () => () => {
  unmountForm(formKey);
  mountForm(formKey);
  showToast(restartResourcesToastDefinition);
  reload();
};

const FormLayout = ({ fields, error, buttons, bindings: { values } }) => (
  <form>
    <div className="heading heading-sm">
      <h2 className="h3">LogHub Settings</h2>
    </div>
    <div className="row">
      <div className="col-6">{fields.get('property_endpoint')}</div>
      <div className="col-6">{fields.get('property_basePattern')}</div>
      <div className="col-6">{fields.get('property_username')}</div>
      <div className="col-6">
        <div className="form-group--toggle">
          {fields.get('property_password')}
          {fields.get('changeProperty_password')}
        </div>
      </div>
    </div>
    <div className="form-group--toggle">
      {!values.get('changeProperty_rootPem')
        ? fields.get('property_rootPem')
        : fields.get('property_new_rootPem')}
      {fields.get('changeProperty_rootPem')}
    </div>
    {error}
    <div className="form-buttons">{buttons}</div>
  </form>
);

export const SystemSetupLoghub = () => {
  return (
    <div className="content-container">
      <SystemElasticSearchForm
        formKey={formKey}
        onSave={handleSave}
        components={{
          FormError,
          FormButtons: generateFormButtons({
            submitLabel: 'Update LogHub Settings',
            cancelPath: '/system/setup/config',
          }),
          FormLayout,
        }}
        alterFields={() =>
          ({ certificateFields }) =>
            certificateFields &&
            certificateFields
              .reduce(
                (reduction, name) =>
                  reduction.set(`property_${name}`, {
                    renderAttributes: {
                      filename: `loghub_${name}.pem`,
                    },
                  }),
                Map(),
              )
              .toObject()
          }
      >
        {({ form }) => form}
      </SystemElasticSearchForm>
    </div>
  );
};
